// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-content2{
    overflow-y: auto;
    overflow-x: hidden;
    min-height: calc(100vh - 70px);
    margin-top: 70px;
    margin-left: 260px;
    width: calc(100% - 260px);
    padding-bottom: 20px;
}

.main-content2:has(.nlp-engine-page) {
    margin-top: 80px;
    padding: 0;
    padding-bottom: 0;
    overflow: hidden;
    height: calc(100vh - 80px);
    min-height: 0;
}

.sidebar-backdrop {
    display: none;
}

@media (max-width: 768px) {
    .main-content2 {
        margin-left: 0;
        width: 100%;
        margin-top: 64px;
        min-height: calc(100vh - 64px);
        min-height: calc(100dvh - 64px);
        /* Keep gutters on the page components to avoid double padding */
        padding: 0 0 max(16px, env(safe-area-inset-bottom));
        box-sizing: border-box;
    }

    /* Chat pages: fill viewport without extra outer scroll */
    .main-content2:has(.kedb-chat),
    .main-content2:has(.wsa-chat),
    .main-content2:has(.nlp-engine-page) {
        margin-top: 64px;
        padding: 0;
        overflow: hidden;
        height: calc(100dvh - 64px);
        min-height: 0;
    }

    .sidebar-backdrop {
        display: block;
        position: fixed;
        inset: 64px 0 0 0;
        background: rgba(15, 23, 42, 0.45);
        border: none;
        padding: 0;
        margin: 0;
        z-index: 1090;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
    }
}
`, "",{"version":3,"sources":["webpack://./src/layout/style.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,8BAA8B;QAC9B,+BAA+B;QAC/B,gEAAgE;QAChE,mDAAmD;QACnD,sBAAsB;IAC1B;;IAEA,yDAAyD;IACzD;;;QAGI,gBAAgB;QAChB,UAAU;QACV,gBAAgB;QAChB,2BAA2B;QAC3B,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,kCAAkC;QAClC,YAAY;QACZ,UAAU;QACV,SAAS;QACT,aAAa;QACb,eAAe;QACf,wCAAwC;IAC5C;AACJ","sourcesContent":[".main-content2{\n    overflow-y: auto;\n    overflow-x: hidden;\n    min-height: calc(100vh - 70px);\n    margin-top: 70px;\n    margin-left: 260px;\n    width: calc(100% - 260px);\n    padding-bottom: 20px;\n}\n\n.main-content2:has(.nlp-engine-page) {\n    margin-top: 80px;\n    padding: 0;\n    padding-bottom: 0;\n    overflow: hidden;\n    height: calc(100vh - 80px);\n    min-height: 0;\n}\n\n.sidebar-backdrop {\n    display: none;\n}\n\n@media (max-width: 768px) {\n    .main-content2 {\n        margin-left: 0;\n        width: 100%;\n        margin-top: 64px;\n        min-height: calc(100vh - 64px);\n        min-height: calc(100dvh - 64px);\n        /* Keep gutters on the page components to avoid double padding */\n        padding: 0 0 max(16px, env(safe-area-inset-bottom));\n        box-sizing: border-box;\n    }\n\n    /* Chat pages: fill viewport without extra outer scroll */\n    .main-content2:has(.kedb-chat),\n    .main-content2:has(.wsa-chat),\n    .main-content2:has(.nlp-engine-page) {\n        margin-top: 64px;\n        padding: 0;\n        overflow: hidden;\n        height: calc(100dvh - 64px);\n        min-height: 0;\n    }\n\n    .sidebar-backdrop {\n        display: block;\n        position: fixed;\n        inset: 64px 0 0 0;\n        background: rgba(15, 23, 42, 0.45);\n        border: none;\n        padding: 0;\n        margin: 0;\n        z-index: 1090;\n        cursor: pointer;\n        -webkit-tap-highlight-color: transparent;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
